import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line zillow/react/prefer-stateless-function
var Label = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Label, _Component);
  function Label() {
    return _Component.apply(this, arguments) || this;
  }
  var _proto = Label.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      label = _this$props.label,
      orient = _this$props.orient,
      width = _this$props.width,
      offset = _this$props.offset,
      height = _this$props.height;
    var horizontalTransform = 'rotate(270)';
    var verticalTransform = 'rotate(0)';
    var textAnchor = 'middle';
    var strokeWidth = '0.01';
    if (label) {
      // eslint-disable-next-line default-case
      switch (orient) {
        case 'top':
        case 'bottom':
          return /*#__PURE__*/React.createElement("text", {
            strokeWidth: strokeWidth,
            textAnchor: textAnchor,
            transform: verticalTransform,
            x: width / 2,
            y: offset
          }, label);
        case 'left':
          return /*#__PURE__*/React.createElement("text", {
            strokeWidth: strokeWidth,
            textAnchor: textAnchor,
            transform: horizontalTransform,
            y: -offset,
            x: -height / 2
          }, label);
        case 'right':
          return /*#__PURE__*/React.createElement("text", {
            strokeWidth: strokeWidth,
            textAnchor: textAnchor,
            transform: horizontalTransform,
            y: offset,
            x: -height / 2
          }, label);
      }
    }
    return /*#__PURE__*/React.createElement("text", null);
  };
  return Label;
}(Component);
Label.propTypes = process.env.NODE_ENV !== "production" ? {
  height: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  horizontalTransform: PropTypes.string,
  label: PropTypes.string.isRequired,
  width: PropTypes.number,
  orient: PropTypes.string,
  // Just to satisfy eslint
  // eslint-disable-next-line zillow/react/forbid-prop-types
  offset: PropTypes.any
} : {};
var Label$1 = Label;

export { Label$1 as default };
